module.exports = __webpack_public_path__ + "img/0xcf6bb5389c92bdda8a3747ddb454cb7a64626c63.5d264400.png";